import { useEffect, useRef } from "react";
import * as echarts from 'echarts';
import { PieProps } from "../../services/Models/ICharts";
import { chartsTheme } from "./ChartsTheme";
import { EChartOption } from "echarts";


export const Pie = (props: PieProps) => {

    const chartRef = useRef<HTMLDivElement>(null);
    const chartInstanceRef = useRef<echarts.EChartsType | null>(null);

    useEffect(() => {
        // Register the custom theme
        echarts.registerTheme('chartsTheme', chartsTheme.theme);

        // Initialize chart
        if (chartRef.current) {
            chartInstanceRef.current = echarts.init(chartRef.current, 'chartsTheme');
        }

        const options: EChartOption = {
            title: {
                text: 'Referer of a Website',
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: '5%',
                left: 'center'
            },
            series: [
                {
                    name: 'Access From',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: false,
                            fontSize: 40,
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: true
                    },
                    data: props.data
                }
            ]
        };

        // Set options
        chartInstanceRef.current?.setOption(options);

        // Handle resize
        const handleResize = () => {
            chartInstanceRef.current?.resize();
        };
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            chartInstanceRef.current?.dispose();
            chartInstanceRef.current = null;
            window.removeEventListener('resize', handleResize);
        };
    }, [props.data, props.title]);

    return <div className="rounded-lg shadow-lg" ref={chartRef} style={{ width: `${props.width}px`, height: `${props.height}px` }} />;
}